module.exports = __webpack_public_path__ + "img/silver-card.71b199df.png";